// Size modal tabs
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('khan-tab')) {
    var modal = e.target.closest('.khan-size-modal');
    modal.querySelectorAll('.khan-tab').forEach(function(t) { t.classList.remove('active'); });
    modal.querySelectorAll('.khan-tab-panel').forEach(function(p) { p.classList.remove('active'); });
    e.target.classList.add('active');
    modal.querySelector('[data-panel="' + e.target.dataset.tab + '"]').classList.add('active');
  }
});
// Close modal on backdrop click
document.addEventListener('click', function(e) {
  var modal = document.getElementById('khanSizeModal');
  if (modal && e.target === modal) modal.close();
});
